import baseURL from "../common/axios";
class Commonservices {
  GetMenus(Type, RoleId, ApplicationType, OrganizationId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Menu/GetMenuSubMenuList?Type=" +
        Type +
        "&RoleId=" +
        RoleId +
        "&ApplicationType=" +
        ApplicationType +
        "&OrganizationId=" +
        OrganizationId +
        ""
    );
  }
  CheckMenuRights(EntityId, RoleId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "EntityOperationsDeptRoleMap/CheckMenuRights?EntityId=" +
        EntityId +
        "&RoleId=" +
        RoleId +
        ""
    );
  }
}
export default new Commonservices();
